import { gql } from "@apollo/client";

export const courseTypeSearch = gql`
  query groupsManagerData($scenarioId: ID!, $filter: AcademicUnitFilterInput!) {
    data(scenarioId: $scenarioId) {
      groupsManagerCourseTypes(filter: $filter) {
        items {
          id
          name
        }
        pageInfo {
          size
          page
          total
          hasNextPage
          hasPreviousPage
        }
        __typename
      }
      __typename
    }
  }
`;
